/**
 * Type of call/interaction
 */
export enum ContactCallType {
  PHONE = 'phone',
  VIDEO_CALL = 'video_call',
  WHATSAPP_CALL = 'whatsapp_call',
}

/**
 * Direction of the call
 */
export enum ContactCallDirection {
  OUTBOUND = 'outbound',
  INBOUND = 'inbound',
}

/**
 * ContactCallLog type for frontend
 */
export interface ContactCallLog {
  id: number;
  callType: ContactCallType;
  callDirection: ContactCallDirection;
  callDate: string;
  durationSeconds?: number | null;
  phoneNumber?: string | null;
  notes?: string | null;
  createdByUserId: string;
  contactId: number;
  createdAt: string;
  updatedAt: string;
}

/**
 * DTO for creating a new call log
 */
export interface CreateContactCallLogDto {
  contactId: number;
  callType?: ContactCallType;
  callDirection?: ContactCallDirection;
  callDate?: string;
  durationSeconds?: number;
  phoneNumber?: string;
  notes?: string;
  createdByUserId: string;
}

/**
 * DTO for updating a call log (mainly for notes)
 */
export interface UpdateContactCallLogDto {
  notes?: string;
  callType?: ContactCallType;
  callDirection?: ContactCallDirection;
}

/**
 * Labels for call types (Dutch)
 */
export const CONTACT_CALL_TYPE_LABELS: Record<ContactCallType, string> = {
  [ContactCallType.PHONE]: 'Telefoongesprek',
  [ContactCallType.VIDEO_CALL]: 'Videogesprek',
  [ContactCallType.WHATSAPP_CALL]: 'WhatsApp gesprek',
};

/**
 * Labels for call directions (Dutch)
 */
export const CONTACT_CALL_DIRECTION_LABELS: Record<ContactCallDirection, string> = {
  [ContactCallDirection.OUTBOUND]: 'Uitgaand',
  [ContactCallDirection.INBOUND]: 'Inkomend',
};
